import React from 'react';
import { Radio, FormControlLabel, Typography, Box } from '@mui/material';

interface CaptionItemProps {
  id: string;
  fileName: string;
  language: string;
  selected: boolean;
  onSelect: (id: string) => void;
}

const CaptionItem = ({ id, fileName, language, selected, onSelect }: CaptionItemProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 1,
        borderBottom: '1px solid #f0f0f0',
        '&:last-child': {
          borderBottom: 'none'
        }
      }}
    >
      <FormControlLabel
        control={
          <Radio
            checked={selected}
            onChange={() => onSelect(id)}
            sx={{
              color: '#006684',
              '&.Mui-checked': {
                color: '#006684',
              }
            }}
          />
        }
        label=""
        sx={{ margin: 0 }}
      />
      <Typography
        variant="body2"
        sx={{
          flex: 1,
          ml: 1,
          fontSize: '14px'
        }}
      >
        {fileName}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: '12px',
          color: 'text.secondary',
          fontStyle: 'italic'
        }}
      >
        ({language})
      </Typography>
    </Box>
  );
};

export default CaptionItem;